export default __webpack_public_path__ + "img/ac499398820d591528dbb96871e273f0.png";